import React from 'react';
import { MapPin, Phone, Mail, Clock, Shield, Home, Users, FileText } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const WebsiteFooter = () => {
  const { language } = useLanguage();
  const footerData = {
    departments: [
      { name: { marathi: 'गृहनिर्माण विभाग', english: 'Housing Department' }, link: '#', icon: <Home size={16} /> },
      { name: { marathi: 'वाहतूक आणि रस्ता विभाग', english: 'Transport & Road Dept' }, link: '#', icon: <Users size={16} /> },
      { name: { marathi: 'आर्थिक आणि कायदे विभाग', english: 'Finance & Law Dept' }, link: '#', icon: <FileText size={16} /> },
    ],
    services: [
      { name: { marathi: 'आपत्कालीन सेवा -108', english: 'Emergency Service - 108' }, link: '#' },
      { name: { marathi: 'आरोग्य व सुरक्षा -108', english: 'Health & Safety - 108' }, link: '#', icon: <Shield size={16} /> },
      { name: { marathi: 'पोलिस -100', english: 'Police - 100' }, link: '#' },
      { name: { marathi: 'अग्निशमन दल -101', english: 'Fire Brigade - 101' }, link: '#' },
      { name: { marathi: 'महिला सुरक्षा -1091', english: 'Women Safety - 1091' }, link: '#' },
    ],
    contactInfo: [
      { 
        icon: <MapPin size={18} />, 
        text: { marathi: 'इनाम धामणी ता. मिरज, जि. सांगली', english: 'Inam Dhamani, Taluka Miraj, Dist. Sangli' } 
      },
      { 
        icon: <MapPin size={18} />, 
        text: { marathi: 'पिन कोड: 416416, महाराष्ट्र', english: 'Pincode: 416416, Maharashtra' } 
      },
      { 
        icon: <Phone size={18} />, 
        text: { marathi: '+91-9588604262', english: '+91-9588604262' } 
      },
      { 
        icon: <Mail size={18} />, 
        text: { marathi: 'grampanchayatinamdhamani@gmail.com', english: 'grampanchayatinamdhamani@gmail.com' } 
      },
      { 
        icon: <Clock size={18} />, 
        text: { marathi: 'कामकाज वेळ: 10am to 6pm, रविवार: सुट्टी', english: 'Working Hours: 10am to 6pm, Sunday: Closed' } 
      },
    ],
    quickLinks: [
      { name: { marathi: 'मुखपृष्ठ', english: 'Home' }, link: '#' },
      { name: { marathi: 'आमच्याविषयी', english: 'About Us' }, link: '#' },
      { name: { marathi: 'आमच्याशी संपर्क साधा', english: 'Contact Us' }, link: '#' },
      { name: { marathi: 'सेवा आणि योजना', english: 'Services & Schemes' }, link: '#' },
      { name: { marathi: 'नागरी सेवा', english: 'Citizen Services' }, link: '#' },
    ],
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-950 text-white print:hidden">
      {/* Top Section with Branding */}
      {/* <div className="bg-gradient-to-r from-blue-900 via-blue-800 to-cyan-800 py-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="text-center md:text-left mb-4 md:mb-0">
              <h2 className="text-3xl font-bold tracking-wide">
              
              </h2>
              <p className="text-gray-200 mt-1" style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }}>
                इनाम धामणी ग्रामपंचायत पोर्टल
              </p>
            </div>
            <div className="text-center md:text-right">
              <p className="text-lg font-semibold text-yellow-300" style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }}>
                "सर्वसामान्यांच्या सेवेसाठी"
              </p>
              <p className="text-gray-300 text-sm mt-1" style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }}>
                एकत्रित विकासाची दिशा
              </p>
            </div>
          </div>
        </div>
      </div> */}

      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          
          {/* Brand and Contact Info */}
          <div className="lg:col-span-2">
            <div className="bg-gray-800/50 rounded-xl p-6 border-l-4 border-yellow-500">
              <h3 className="text-xl font-bold text-yellow-400 mb-4 flex items-center gap-2">
                <span className="p-2 bg-yellow-500/20 rounded-lg">
                  <MapPin size={20} />
                </span>
                {language === 'marathi' ? 'संपर्क माहिती' : 'Contact Info'}
              </h3>
              <div className="space-y-4">
                {footerData.contactInfo.map((item, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="text-yellow-400 mt-1">
                      {item.icon}
                    </div>
                    <p className="text-gray-300" style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }}>
                      {item.text[language] || item.text.marathi}
                    </p>
                  </div>
                ))}
              </div>
              <div className="mt-6 pt-6 border-t border-gray-700">
                <h4 className="text-lg font-semibold text-white mb-3">{language === 'marathi' ? 'ताजे अपडेट्स' : 'Latest Updates'}</h4>
                <div className="bg-gray-900 rounded-lg p-4">
                  <p className="text-sm text-gray-300" style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }}>
                    {language === 'marathi' ? 'नवीनतम सरकारी योजनांची माहिती आणि अपडेट्ससाठी आमच्या वेबसाइटवर भेट द्या.' : 'Visit our website for the latest government schemes and updates.'}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* विभाग Section */}
          <div>
            <h3 className="text-xl font-bold text-white mb-6 pb-3 border-b border-blue-600 flex items-center">
              <span className="w-2 h-6 bg-blue-500 rounded-full mr-3"></span>
              {language === 'marathi' ? 'विभाग' : 'Departments'}
            </h3>
            <ul className="space-y-3">
              {footerData.departments.map((dept, index) => (
                <li key={index}>
                  <a 
                    href={dept.link} 
                    className="flex items-center gap-3 p-2 rounded-lg hover:/50 transition-all duration-300 group bg-[#f2ede4] text-black hover:opacity-80"
                  >
                    <span className="text-blue-400 group-hover:text-yellow-400 transition-colors">
                      {dept.icon}
                    </span>
                    <span 
                      className="group-hover:text-yellow-300 transition-colors"
                      style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }}
                    >
                      {dept.name[language] || dept.name.marathi}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* सेवा Section */}
          <div>
            <h3 className="text-xl font-bold text-white mb-6 pb-3 border-b border-green-600 flex items-center">
              <span className="w-2 h-6 bg-green-500 rounded-full mr-3"></span>
              {language === 'marathi' ? 'विभाग व सेवा' : 'Services'}
            </h3>
            <ul className="space-y-3">
              {footerData.services.map((service, index) => (
                <li key={index}>
                  <a 
                    href={service.link} 
                    className="flex items-center gap-3 p-2 rounded-lg hover:/50 transition-all duration-300 group bg-[#f2ede4] text-black hover:opacity-80"
                  >
                    <span className="text-green-400 group-hover:text-yellow-400 transition-colors">
                      {service.icon || <Shield size={16} />}
                    </span>
                    <span 
                      className="group-hover:text-yellow-300 transition-colors"
                      style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }}
                    >
                      {service.name[language] || service.name.marathi}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold text-white mb-6 pb-3 border-b border-purple-600 flex items-center">
              <span className="w-2 h-6 bg-purple-500 rounded-full mr-3"></span>
              {language === 'marathi' ? 'दुवे' : 'Links'}
            </h3>
            <ul className="space-y-3">
              {footerData.quickLinks.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.link} 
                    className="flex items-center gap-3 p-2 rounded-lg hover:/50 transition-all duration-300 group bg-[#f2ede4] text-black hover:opacity-80"
                  >
                    <span className="text-purple-400 group-hover:text-yellow-400 transition-colors">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </span>
                    <span 
                      className="group-hover:text-yellow-300 transition-colors"
                      style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }}
                    >
                      {link.name[language] || link.name.marathi}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
            
            {/* Social Links */}
            <div className="mt-8 pt-6 border-t border-gray-700">
              <h4 className="text-lg font-semibold text-white mb-4">{language === 'marathi' ? 'सोशल मीडिया' : 'Social Media'}</h4>
              <div className="flex gap-4">
                {[
                  { name: 'Facebook', color: 'bg-blue-600', icon: 'F' },
                  { name: 'Twitter', color: 'bg-sky-500', icon: 'T' },
                  { name: 'Instagram', color: 'bg-pink-600', icon: 'I' },
                  { name: 'YouTube', color: 'bg-red-600', icon: 'Y' },
                ].map((social, index) => (
                  <a
                    key={index}
                    href="#"
                    className={`${social.color} w-10 h-10 rounded-full flex items-center justify-center font-bold hover:scale-110 transition-transform duration-300`} aria-label={social.name} > {social.icon} </a> ))} </div> </div> </div> </div> </div> 
      {/* Bottom Footer */} 
      <div className="/80 border-t border-gray-800"> 
        <div className="container mx-auto px-4 py-6"> 
          <div className="flex flex-col md:flex-row justify-between items-center"> 
            <div className=" md: mb-4 md:mb-0"> 
              <div className="flex items-center justify-center md:justify-start gap-2 mb-2"> 
                <div className="w-8 h-8 rounded-lg flex items-center justify-center"> <span className="font-bold ">ID</span> </div> 
                <div> <p className=" font-bold ">INAM DHAMNI</p> <p className=" ">Gram Panchayat Portal</p> </div> 
              </div> 
              <p className=" " style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }} > © {new Date().getFullYear()} {language === 'marathi' ? 'इनाम धामणी ग्रामपंचायत' : 'Inam Dhamni Gram Panchayat'} </p> 
            </div> 
            <div className="flex flex-wrap justify-center gap-4"> 
              <a href="#" className="hover: transition-colors duration-300 px-3 py-1 rounded-full hover:/50 ] hover:opacity-80" style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }} > {language === 'marathi' ? 'गोपनीयता धोरण' : 'Privacy Policy'} </a> 
              <span className=" hidden md:block">•</span> 
              <a href="#" className="hover: transition-colors duration-300 px-3 py-1 rounded-full hover:/50 ] hover:opacity-80" style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }} > {language === 'marathi' ? 'सेवा अटी' : 'Terms of Service'} </a> 
              <span className=" hidden md:block">•</span> 
              <a href="#" className="hover: transition-colors duration-300 px-3 py-1 rounded-full hover:/50 ] hover:opacity-80" style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }} > {language === 'marathi' ? 'साईट मॅप' : 'Sitemap'} </a> 
              <span className=" hidden md:block">•</span> 
              <a href="#" className="hover: transition-colors duration-300 px-3 py-1 rounded-full hover:/50 ] hover:opacity-80" style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }} > {language === 'marathi' ? 'मदत केंद्र' : 'Help Center'} </a> 
            </div> 
          </div> 
        </div> 
      </div> 
      {/* Important Notice Bar */} 
      <div className=" /30 /30 py-3 border-y border-gray-800"> 
        <div className="container mx-auto px-4"> 
          <div className="flex items-center justify-center gap-3"> 
            <div className="animate-pulse"> <svg className="w-5 h-5 " fill="currentColor" viewBox="0 0 20 20"> <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" /> </svg> </div> 
            <p className=" " style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }}> {language === 'marathi' ? 'आपत्कालीन परिस्थितीत कृपया १०८ किंवा ११२ या क्रमांकावर संपर्क साधा' : 'In case of emergency, please contact 108 or 112'} </p> 
            <div className="animate-pulse"> <svg className="w-5 h-5 " fill="currentColor" viewBox="0 0 20 20"> <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" /> </svg> </div> 
          </div> 
        </div> 
      </div> 
      {/* Inline styles for fonts */} <style jsx>{` @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;500;600;700&display=swap'); /* Custom animations */ @keyframes float { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-5px); } } .animate-float { animation: float 3s ease-in-out infinite; } `}</style>
    </footer>
  );
};

export default WebsiteFooter;
